import { Routes } from '@angular/router';
import { adminGuard } from '@huddle-sports-platform/app-core';

import { shellChildren } from './shell/shell.routes';

export const routes: Routes = [
  {
    path: 'sign-in',
    loadComponent: () => import('./pages/sign-in.page').then((m) => m.SignInPage),
  },
  {
    path: 'not-authorised',
    loadComponent: () => import('./pages/not-authorised.page').then((m) => m.NotAuthorisedPage),
  },
  {
    path: '',
    loadComponent: () => import('./shell/shell').then((m) => m.Shell),
    children: shellChildren,
    canActivate: [adminGuard],
    canActivateChild: [adminGuard],
  },
  { path: '**', redirectTo: 'dashboard/overview' },
];
